module.exports = __webpack_public_path__ + "static/media/Visualisation.8c0ea87c.jpg";